import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { AlertTriangle } from "lucide-react";

export default function LowStockTile() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/analytics/low-stock")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <div className="brut p-4 bg-white mt-6" data-testid="low-stock-tile">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <AlertTriangle size={20} strokeWidth={3} />
          <h3 className="font-display text-2xl uppercase">Low stock</h3>
          {items.length > 0 && (
            <span className="tag-sticker bg-pink text-white text-sm">{items.length}</span>
          )}
        </div>
        <span className="text-xs opacity-70">items with qty ≤ 1 — restock or relist before they're gone</span>
      </div>
      {items.length === 0 ? (
        <div className="text-sm opacity-60 text-center py-6">All stocked. Nothing on the brink.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((it) => (
            <Link
              to={`/item/${it.id}`}
              key={it.id}
              className="brut-sm p-2 flex items-center gap-3 bg-paper hover:-translate-y-0.5 transition-transform"
              data-testid={`low-stock-${it.id}`}
            >
              <div className="w-14 h-14 brut-sm overflow-hidden flex-shrink-0">
                {it.images?.[0] ? <img src={fileUrl(it.images[0])} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-[#f3efe6]" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-sm uppercase truncate">{it.title}</div>
                <div className="text-xs opacity-70">{it.category} · {it.size}</div>
              </div>
              <span className={`tag-sticker text-xs ${it.quantity === 0 ? "bg-pink text-white" : "bg-yellow"}`}>
                {it.quantity === 0 ? "out" : "last 1"}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
